<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn dark icon v-on="on" v-bind="attrs" class="mx-2">
        <v-icon>mdi-account-cog</v-icon>
      </v-btn>
    </template>

    <v-card class="mx-auto" max-width="500" width="300">
      <template v-if="!loginScreen">
        <v-card-title>
          <template v-if="account.user != null">
            {{ account.user.firstName }}
            {{ account.user.lastName }}
          </template>
          <template v-else>
            Host
          </template>
        </v-card-title>
      </template>
      <v-list style="max-height: 500px" class="overflow-y-auto">
        <v-list-group prepend-icon="mdi-palette" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $t("app.appearance") }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-group prepend-icon="mdi-theme-light-dark" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("app.theme.header")
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item>
              <!--<v-switch
                color="primary"
                v-model="isDark"
                :label="$t('app.theme.dark')"
              ></v-switch> -->

              <v-radio-group v-model="isDark">
                <v-radio :label="$t('app.theme.dark')" :value="true"></v-radio>
                <v-radio
                  :label="$t('app.theme.light')"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="mdi-palette" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ $t("app.colors") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item>
              <ColorThemes />
            </v-list-item>
          </v-list-group>

          <!--           <v-list-group prepend-icon="mdi-palette" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Color Palete</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item>
              <ColorThemes :picker="true" />
            </v-list-item>
          </v-list-group> -->
        </v-list-group>
        <v-list-group prepend-icon="mdi-translate" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $t("app.language") }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item>
            <LanguageSwitcher />
          </v-list-item>
        </v-list-group>

        <template v-if="!loginScreen">
          <v-divider></v-divider>
          <v-list-item @click="btnClickLogout()">
            {{ $t("app.logout") }}
            <v-spacer></v-spacer>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import ColorThemes from "../account/core/ColorThemes.vue";
import LanguageSwitcher from "../account/core/LanguageSwitcher.vue";

import { mapState } from "vuex";

export default {
  name: "AccountMenu",
  components: {
    ColorThemes,
    LanguageSwitcher,
  },
  props: {
    loginScreen: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data() {
    return {
      radioGroup: 0,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    isDark: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        localStorage.setItem("darkTheme", this.$vuetify.theme.dark);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    btnClickLogout() {
      var retrievedObject = JSON.parse(localStorage.getItem("login"));
      retrievedObject.autoLogin = false;
      /* retrievedObject.password = ""; */
      localStorage.setItem("login", JSON.stringify(retrievedObject));

      this.$router.push({ path: "login" });
    },
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
